import { type Material } from '@babylonjs/core/Materials/material';
import { type Mesh } from '@babylonjs/core/Meshes/mesh';
import { type TransformNode } from '@babylonjs/core/Meshes/transformNode';
import { type AssetContainer } from '@babylonjs/core/assetContainer';
import { type Scene } from '@babylonjs/core/scene';
import { type Nullable } from '@babylonjs/core/types';
import { type IVector3 } from '@seddi/math-v2';
import { type GarmentGeometryThreadLine, GarmentGeometrySplineMesher } from '@seddi/scene';
import { MeshExt } from '@seddi/ui-babylon-core';
import { ThreadMaterial } from '../materials/threadMaterial';

export class StitchLoader {
  private readonly scene: Scene;

  private _assetContainer: Nullable<AssetContainer> = null;

  constructor(scene: Scene) {
    this.scene = scene;
  }

  loadAssetContainer(
    id: string,
    stitch: GarmentGeometryThreadLine,
    color: IVector3,
    parent: TransformNode,
    container: Nullable<AssetContainer> = null,
  ): Mesh {
    this._assetContainer = container;
    return this._load(id, stitch, color, parent);
  }

  load(
    id: string,
    stitch: GarmentGeometryThreadLine,
    color: IVector3,
    parent: TransformNode,
  ): Mesh {
    return this._load(id, stitch, color, parent);
  }

  _load(
    id: string,
    stitch: GarmentGeometryThreadLine,
    color: IVector3,
    parent: TransformNode,
  ): Mesh {
    const geometry = GarmentGeometrySplineMesher.Mesh(stitch, 3.0);
    this.scene._blockEntityCollection = Boolean(this._assetContainer);
    const mesh = MeshExt.create(id, this.scene, parent);
    MeshExt.applyGeometry(mesh, geometry);
    const material = this._touchMaterial(color);
    this.scene._blockEntityCollection = false;
    mesh.material = material;
    return mesh;
  }

  private _touchMaterial(color: IVector3): Material {
    const { x, y, z } = color;

    const materialId = `${x}-${y}-${z}`;
    const found = this.scene.materials.find(({ id }) => id === materialId);

    if (found) {
      return found;
    }
    return ThreadMaterial.create(color, this.scene);
  }
}
